export const productConfigs = [
  {
    id: 'VPRIME',
    entryId: 'blt8b39d9c30ef08ea5'
  },
  {
    id: 'MMP',
    entryId: 'bltf4969d7148c3ae5d'
  },
  {
    id: 'MTR',
    entryId: 'bltca03f03232eca9b6'
  },
  {
    id: 'BIGT',
    entryId: 'bltaa2d5b213c88aa25'
  }
]

export const PRODUCT_ID = {
  // Life products
  CANSURANCE: 'CRP',
  MYMILLION: 'MMP',
  VPRIME: 'VPRIME',
  MYCOVER: 'BIGT',
  MYTERM: 'MTR',
  MYSAFE: 'ATC2',
  VCARE: 'VSF',
  MYTRAVEL: 'MYTRAVEL',
} as const

const MYCOVER_RENEWAL_MAPPING = [
  {
    planId: 'B1',
    planCode: 'BIGT',
    optionCode: 'B1',
    renewablePeriod: '1',
  },
  {
    planId: 'B1',
    planCode: 'BIGT',
    optionCode: 'B10',
    renewablePeriod: '10',
  },
  {
    planId: 'B2',
    planCode: 'BIGT',
    optionCode: 'B2',
    renewablePeriod: '1',
  },
  {
    planId: 'B2',
    planCode: 'BIGT',
    optionCode: 'B20',
    renewablePeriod: '10',
  },
  {
    planId: 'AB2',
    planCode: 'BIGT',
    optionCode: 'AB2',
    renewablePeriod: '1',
  },
]


const MYTERM_RENEWAL_MAPPING = [
  {
    planId: 'HTN',
    planCode: 'HTN1',
    optionCode: 'S',
    renewablePeriod: '1',
  },
  {
    planId: 'HTN',
    planCode: 'HTN2',
    optionCode: 'S',
    renewablePeriod: '10',
  },
  {
    planId: 'HTO',
    planCode: 'HTO1',
    optionCode: 'P',
    renewablePeriod: '1',
  },
  {
    planId: 'HTO',
    planCode: 'HTO2',
    optionCode: 'P',
    renewablePeriod: '10',
  },
]

export const getProductPlanConfig = (
  productId: string,
  planId: string,
  {
    deductible,
    renewablePeriod,
    sumInsured,
  }: {
    deductible: number
    renewablePeriod: string
    sumInsured: number
  }
): { planCode: string; optionCode: string; classes?: { classlevel1: string; classlevel2: string } } | undefined => {
  // MYCOVER
  if (productId === PRODUCT_ID.MYCOVER) {
    return MYCOVER_RENEWAL_MAPPING.find(x => x.planId === planId && x.renewablePeriod === renewablePeriod)
  }

  // MYMILLION
  if (productId === PRODUCT_ID.MYMILLION) {
    return {
      planCode: 'HMM1',
      optionCode: '',
      classes: {
        classlevel1: planId,
        classlevel2: String(deductible),
      },
    }
  }

  // MYTERM
  if (productId === PRODUCT_ID.MYTERM) {
    return MYTERM_RENEWAL_MAPPING.find(x => x.planId === planId && x.renewablePeriod === renewablePeriod)
  }


  // VPRIME
  if (productId === PRODUCT_ID.VPRIME) {
    return {
      planCode: planId,
      optionCode: 'HKD' + deductible,
    }
  }
}